export default {
    colors: {
        background: "rgba(0,0,0,0.25)",
        boxBackground: "#fff",
        textColor: "#141414",
        linkColor: "#2458a1"
    }
  };